import EVisitsEdit from './e-visits-edit';

export default EVisitsEdit;
